import React from 'react'
import { inject, observer } from 'mobx-react'
import styled from 'styled-components'

import Spacer from '~/components/Spacer'
import GoogleButton from '~/components/auth/LoginWithButtons/GoogleButton'
import TRACKING from '~/services/tracking'

const Container = styled.div`
  margin: ${(props) => (props.$alignWithEmailField ? '0' : '2px 0')};
  width: 100%;
`

/** Matches InputItemWrapper spacing used by LabeledSimpleInput (Email field). */
const EmailAlignedField = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  margin-bottom: 1rem;
  width: 100%;
`

const EmptyLabel = styled.span`
  font-family: ${(props) => props.theme.parking.fonts.grotesk};
  font-size: 16px;
  line-height: 21px;
  color: transparent;
  user-select: none;
`

const Divider = styled.div`
  display: flex;
  align-items: center;
  text-align: center;
  color: ${(props) => props.theme.parking.colors.onSurfaceVariant};
  font-family: ${(props) => props.theme.parking.fonts.grotesk};
  font-size: 0.85rem;
  margin: 12px 0;

  &::before,
  &::after {
    content: '';
    flex: 1;
    border-bottom: 1px solid ${(props) => props.theme.parking.colors.outlineVariant};
  }

  span {
    padding: 0 10px;
  }
`

const ContinueWithButtons = ({ trackCheckoutLogin, isPayNYCFlow, alignWithEmailField }) => {
  const googleButton = (
    <GoogleButton
      onSuccess={() => {
        if (trackCheckoutLogin && isPayNYCFlow) {
          TRACKING.paynycParking.googleCheckoutLogin(isPayNYCFlow)
        }
      }}
    />
  )

  return (
    <Container $alignWithEmailField={alignWithEmailField}>
      {alignWithEmailField ? (
        <EmailAlignedField>
          <EmptyLabel aria-hidden="true">&nbsp;</EmptyLabel>
          {googleButton}
        </EmailAlignedField>
      ) : (
        googleButton
      )}
      {trackCheckoutLogin ? (
        <Divider>
          <span>or continue with email</span>
        </Divider>
      ) : (
        !alignWithEmailField && <Spacer mobile={10} desktop={25} />
      )}
    </Container>
  )
}

export default inject((all) => ({
  isPayNYCFlow: all.store.ui.isPayNYCFlow,
}))(observer(ContinueWithButtons))
